import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import './utils/fonts.css'

import { Root } from './Root'

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <HashRouter>
    <Root />
  </HashRouter>,
)
